import { render, staticRenderFns } from "./CampaignCounter.vue?vue&type=template&id=12d578fa&scoped=true&"
import script from "./CampaignCounter.vue?vue&type=script&lang=js&"
export * from "./CampaignCounter.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCounter.vue?vue&type=style&index=0&id=12d578fa&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d578fa",
  null
  
)

export default component.exports